<template>
  <div class="salesList">
    <div style="padding-bottom: 20px">
      <el-radio-group v-model="conditions" @change="tabConditions">
        <el-radio-button label="2">按月</el-radio-button>
        <el-radio-button label="3">按年</el-radio-button>
      </el-radio-group>
    </div>
    <div style="margin-bottom: 20px">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
        <el-form-item label="月份区间" label-width="70px" v-if="conditions === '2'">
          <el-date-picker
              @input="search"
              v-model="searchForm.monthTime"
              type="monthrange"
              style="width: 220px"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="年份区间" label-width="70px" v-if="conditions === '3'">
          <el-date-picker
              @input="search"
              v-model="searchForm.startYear"
              type="year"
              value-format="yyyy"
              style="width: 220px"
              placeholder="开始年份"
              unlink-panels>
          </el-date-picker>
          -
          <el-date-picker
              @input="search"
              v-model="searchForm.endYear"
              type="year"
              style="width: 220px"
              value-format="yyyy"
              unlink-panels
              placeholder="结束年份">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="药房">
          <DicInput @fieldId="fieldId($event,'pharmacyId')" :initName="searchForm.pharmacyId" :dicType="8"></DicInput>
        </el-form-item>
      </el-form>
      <el-button @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          :span-method="objectSpanMethod"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="operatorName"
            :label="timeName">
        </el-table-column>
        <el-table-column
            prop="cupTypeName"
            label="药杯型号">
          <template slot-scope="scope">
            <span>
              {{scope.row.date +'-'+ scope.row.cupTypeName}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
            prop="usedAmount"
            label="总数">
        </el-table-column>
        <el-table-column
            align="center"
            prop="totalAmount"
            label="合计">
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <!--    <div style="margin-top: 20px">-->
    <!--      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'-->
    <!--                  @handleCurrentChange='handleCurrentChange'></Pagination>-->
    <!--    </div>-->
  </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import DicInput from "@/components/DicInput";
export default {
  name: "salesList",
  data() {
    return {
      conditions: "2",
      pickerType:'date',
      searchForm:{
        dayTime: [],
        monthTime: [],
        startYear: '2020',
        endYear: '2021',
      },
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
      tableData:[],
      OrderIndexArr: [],
      timeName:'设备'
    }
  },
  components: {
    //someComponent
    Pagination,
    DicInput
  },
  methods: {
    //
    fieldId(item, name) { // 字典
      if (item.id) {
        this.searchForm[name] = item.id
      } else {
        this.searchForm[name] = ''
      }
    },
    getOrderNumber() {
      let OrderObj = {}
      this.tableData.forEach((element, index) => {
        element.rowIndex = index
        if (OrderObj[element.date]) {
          OrderObj[element.date].push(index)
        } else {
          OrderObj[element.date] = []
          OrderObj[element.date].push(index)
        }
      })

      // 将数组长度大于1的值 存储到this.OrderIndexArr（也就是需要合并的项）
      for (let k in OrderObj) {
        if (OrderObj[k].length > 1) {
          this.OrderIndexArr.push(OrderObj[k])
        }
      }
    },
    objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0 || columnIndex === 3) {
        for (let i = 0; i < this.OrderIndexArr.length; i++) {
          let element = this.OrderIndexArr[i]
          for (let j = 0; j < element.length; j++) {
            let item = element[j]
            if (rowIndex == item) {
              if (j == 0) {
                return {
                  rowspan: element.length,
                  colspan: 1
                }
              } else if (j != 0) {
                return {
                  rowspan: 0,
                  colspan: 0
                }
              }
            }
          }
        }
      }
    },
    tabConditions(){
      let url = ''
      let data = {}
      let start, end
      if (this.conditions === '2') {
        url = '/Statistics/PharmacyStatistics/GetMonthDeviceWorkLoad'
        start = this.searchForm.monthTime[0]
        end = this.searchForm.monthTime[1]
        data = {
          start: start,
          end: end,
          pharmacyId:this.searchForm.pharmacyId,
        }
      } else {
        url = '/Statistics/PharmacyStatistics/GetYearDeviceWorkLoad'
        start = this.searchForm.startYear
        end = this.searchForm.endYear
        data = {
          yearStart: start,
          yearEnd: end,
          pharmacyId:this.searchForm.pharmacyId,
        }
      }
      this.init(url, data)
    },
    search(){
      this.tabConditions()
    },
    init(url, data) {
      this.tableData=[]
      this.axios
          .get(url, {params: data})
          .then((q) => {
            let res=q.list
            //产生分组
            let groups=[];
            for(var i in res){
              this.tableData.push({...res[i],totalamount:0})
              var target=null;
              for(var b in groups){
                if(groups[b].date==res[i].Monhtfrom1970){
                  target=groups[b];
                  break;
                }
              }
              if(target==null){
                groups.push({date:res[i].monthCodeForm1970,amount:res[i].usedAmount})
              }else{
                target.amount+=res[i].usedAmount;
              }
            }
            //填入数据
            for(var i in this.tableData){
              switch (this.conditions) {
                case "2":
                  this.tableData[i].date=this.tableData[i].year + '-' + this.tableData[i].month
                  break;
                default :
                  this.tableData[i].date=this.tableData[i].year
              }
              for(var b in groups)
              {
                if(this.tableData[i].monthCodeForm1970==groups[b].date) {
                  this.tableData[i].totalAmount = groups[b].amount;
                  break;
                }
              }
            }
            this.getOrderNumber(this.tableData)
          })

    },

    // ----------分页控制-------------
    clear(){
      this.searchForm={
        name:'',
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },
  },
  mounted() {
    //
  }
}
</script>

<style lang="scss" scoped>
.salesList {

}
</style>